import { ComponentType } from 'react';
import { useParamsContext } from '../../contexts/ParamsContext';
import { useNavigate } from 'react-router-dom';
import { useModuleSheet } from './useModuleSheet';
import { ChevronLeft } from 'lucide-react';

interface HeaderProps {
    title: string;
    Actions: ComponentType | any;
    returnHome?: boolean;
    returnTo?: string;
    actionTitles?: Record<string, string>;
    actionParents?: Record<string, string>;
    condensed?: boolean;
}

export default function HeaderContent({
    title,
    Actions,
    returnHome = false,
    returnTo,
    actionTitles,
    actionParents,
    condensed = false,
}: HeaderProps) {
    const navigate = useNavigate();

    const { action, id, clear, setParams } = useParamsContext();
    const moduleSheet = useModuleSheet();
    // Fluxos com titulo proprio (ex.: Agenda > Novo atendimento) ocupam o cabecalho sem as acoes da lista.
    const actionTitle = action ? actionTitles?.[action] : undefined;
    // Detalhe aberto so por `id` (ex.: cliente) ja tem voltar proprio, que retorna para a lista.
    const showBack = !!action || returnHome || (moduleSheet && !id);
    const backLabel = actionTitle ? title : 'Voltar';

    return (
        <div className="flex min-h-11 flex-wrap items-center gap-x-3 gap-y-2">
            <div className="flex min-w-0 flex-1 items-center gap-1 sm:gap-2">
                {showBack && (
                    <button
                        type="button"
                        className="sf-back-button shrink-0"
                        onClick={() => {
                            // `action` volta para a lista da propria pagina; `returnHome` sai da pagina.
                            if (action) {
                                const parent = actionParents?.[action];
                                if (parent) setParams({ action: parent, id: '' });
                                else clear();
                                return;
                            }
                            navigate(returnTo || '/');
                        }}
                        aria-label={backLabel}
                    >
                        <ChevronLeft aria-hidden="true" />
                        <span className="hidden sm:inline">{backLabel}</span>
                    </button>
                )}

                <h1 className={`sf-content-title min-w-0 truncate ${condensed ? 'is-condensed' : ''}`}>
                    {actionTitle || title}
                </h1>
            </div>

            {!actionTitle && (
                <div className="ml-auto flex shrink-0 items-center justify-end">{!!Actions && <Actions />}</div>
            )}
        </div>
    );
}
